import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const ModalTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 2rem;
  font-family: 'Cairo', sans-serif;
`;

const LanguageOption = styled.button`
  width: 100%;
  padding: 1.2rem;
  margin-bottom: 1rem;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  
  &:hover {
    border-color: #3498db;
    background: #f8f9fa;
    transform: translateY(-2px);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const FlagIcon = styled.span`
  font-size: 1.8rem;
`;

const LanguageText = styled.span`
  font-size: 1.1rem;
  font-weight: 500;
`;

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSelectLanguage: (language: 'english' | 'arabic') => void;
  language: 'ar' | 'en';
}

const MathLanguageModal: React.FC<Props> = ({ isOpen, onClose, onSelectLanguage, language }) => {
  if (!isOpen) return null;

  const content = {
    ar: {
      title: 'بأي لغة تريد أن تختبر؟',
      arabic: 'عربي',
      english: 'English'
    },
    en: {
      title: 'Which language do you want to test in?',
      arabic: 'Arabic',
      english: 'English'
    }
  };

  const currentContent = content[language];

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay  onClick={handleBackdropClick}>
      <ModalContent >
        <ModalTitle>{currentContent.title}</ModalTitle>
        
        <LanguageOption onClick={() => onSelectLanguage('arabic')}>
          <FlagIcon>🇰🇼</FlagIcon>
          <LanguageText>{currentContent.arabic}</LanguageText>
        </LanguageOption>
        
        <LanguageOption onClick={() => onSelectLanguage('english')}>
          <FlagIcon>🇬🇧</FlagIcon>
          <LanguageText>{currentContent.english}</LanguageText>
        </LanguageOption>
      </ModalContent>
    </ModalOverlay>
  );
};

export default MathLanguageModal;
